// Batch 34 · C (P6-F7) — an income / expense account's own IFRS 18 category on the FS mapping screen
// (components/PlCategorySettings.jsx), EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B34C = {
  en: {
    plCat: {
      title: "IFRS 18 category of an income or expense account",
      help: "By default an account is presented in the category of its FS code. Set a category when the account belongs elsewhere — for example depreciation of investment property (an expense of an investment: investing category). Used by the IFRS 18 statement of profit or loss and the cash flow.",
      filter: "Find an income or expense account (code or name)",
      byCode: "As its FS code",
      OP: "Operating", INV: "Investing", FIN: "Financing", TAX: "Income taxes",
      set: "set",
      none: "No account matches.",
    },
  },
  ar: {
    plCat: {
      title: "فئة حساب الإيرادات أو المصروفات وفق المعيار الدولي للتقرير المالي 18",
      help: "يُعرض الحساب افتراضيًا في فئة بنده في القوائم المالية. حدِّد فئة إذا كان الحساب ينتمي إلى غيرها — مثل استهلاك العقارات الاستثمارية (مصروف استثمار: الفئة الاستثمارية). تستخدمها قائمة الربح أو الخسارة وفق المعيار 18 وقائمة التدفقات النقدية.",
      filter: "ابحث عن حساب إيرادات أو مصروفات (الرمز أو الاسم)",
      byCode: "حسب بنده في القوائم المالية",
      OP: "تشغيلية", INV: "استثمارية", FIN: "تمويلية", TAX: "ضرائب الدخل",
      set: "محدد",
      none: "لا يوجد حساب مطابق.",
    },
  },
};

export default I18N_B34C;
